@if (buttons().length) {
  <div class="button-group">
    @for (button of buttons(); track button.icon) {
      <button
        class="button-group-button"
        uiTooltip
        [tooltipText]="button.tooltipText"
        [attr.data-testid]="'btn-' + button.tooltipText?.toLowerCase()?.replace(' ', '-')"
        (click)="button.action($event)"
      >
        <ui-inline-svg
          [name]="button.icon"
          class="button-group-button-icon"></ui-inline-svg>
      </button>
    }
  </div>
}
